export default {
    thisFieldIsRequired: "This field is required",
};